import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import LoginFooter from 'components/LoginFooter';
import { cn } from 'utils';
import Header from '../Header';
import Sidebar from '../Sidebar';
import { Helmet, HelmetProvider } from 'react-helmet-async';

interface SeoProps {
  title: string;
  description: string;
  children?: React.ReactNode;
}

const Layout = ({title,description,children} : SeoProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const location = useLocation();

  // 해당 경로들에서만 LoginFooter를 보여주기 위한 조건 설정
  const showLoginFooter = ['/pricing', '/calculator', '/promotion', '/faq', '/contact-us'].includes(location.pathname);

  return (
    <HelmetProvider>
      <Helmet 
        titleTemplate="%s" 
        defaultTitle="All in one solution for Spacecraft" 
        defer={false}
        prioritizeSeoTags={true}
      >
        {title && <title>{title}</title>}
        <meta name="description" content={description} />
        <link rel="icon" href="/iops_favicon.ico" />
      </Helmet>
        <div className={cn('relative flex h-screen max-h-screen flex-row gap-4 overflow-hidden bg-bg-layer1', 'md:p-2')}>
          <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
          <div
            className={cn(
              'relative flex h-full w-full flex-1 flex-col bg-bg-layer2',
              'overflow-hidden md:rounded-lg md:border md:border-border-dimmed'
            )}
          >
            <Header setIsSidebarOpen={setIsSidebarOpen} />
            <main className="z-10 flex h-full w-full flex-1 justify-center overflow-x-hidden">
              {children}
              <Outlet />
            </main>
              {showLoginFooter && <LoginFooter />}
          </div>
        </div>
    </HelmetProvider>
  );
};

export default Layout;
